var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cate"},[_c('div',{staticClass:"list"},[_c('div',{staticClass:"item",style:({ backgroundColor: _vm.configure.color_palette.color3, color: '#fff', fontWeight: 'bold' })},[_vm._v("Category")]),_vm._l((15),function(item){return _c('div',{key:item,staticClass:"item"},[_vm._v("Category")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }